import React from 'react';

/**
 * SpiderWebIcon
 * Simplified spider web icon for Page Scraper
 * - 24x24 viewBox
 * - White stroke, no fill
 * - Clean, minimal design
 */
export const SpiderWebIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Center point */}
    <circle cx="12" cy="12" r="1.5" fill="white" />
    
    {/* Radial lines from center */}
    <path d="M12 12V4" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 12v8" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 12H4" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 12h8" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 12l-5.5-5.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 12l5.5-5.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 12l-5.5 5.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 12l5.5 5.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    
    {/* Concentric circles (web rings) */}
    <circle cx="12" cy="12" r="4" stroke="white" strokeWidth="1.5" fill="none" />
    <circle cx="12" cy="12" r="7" stroke="white" strokeWidth="1.5" fill="none" />
    <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="1.2" fill="none" opacity="0.7" />
  </svg>
);


